// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__lq22j","text":"styles_text__rQ8u1"};